@use '../../../scss/utility/functions' as utility;

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0 utility.wb-pixel-to-rem(8px);
  width: utility.wb-pixel-to-rem(54px);

  &:first-of-type {
    padding-inline-start: 0;
  }
}

::slotted(.wb-spinner) {
  --size: #{utility.wb-pixel-to-rem(24px)};
}
